import React, { useState } from 'react';
import { Search, Loader2, Folder, FileText, CheckCircle2 } from 'lucide-react';

export const TreePreviewTab = ({ api, toast }) => {
  const [ref, setRef] = useState('');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const run = async () => {
    if (!ref.trim()) return;
    setLoading(true);
    try { const r = await api.post('/drive/preview-tree', { appraisal_id: ref.trim() }); setData(r.data); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Job not found'); setData(null); }
    finally { setLoading(false); }
  };

  const n = data?.names;
  return (
    <div className="space-y-4" data-testid="drive-tree-preview-tab">
      <div className="flex items-center gap-2">
        <input data-testid="tree-preview-input" value={ref} onChange={(e) => setRef(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && run()}
          placeholder="Appraisal number, e.g. A4860" className="w-64 px-3 py-2 text-sm border border-[#E2E2DF] rounded focus:outline-none focus:ring-2 focus:ring-[#0F4F1B]/30" />
        <button data-testid="tree-preview-btn" onClick={run} className="inline-flex items-center gap-1.5 px-4 py-2 text-xs font-semibold rounded-md bg-[#0F4F1B] text-white hover:bg-[#0a3c14] transition-colors">
          {loading ? <Loader2 size={13} className="animate-spin" /> : <Search size={13} />} Show folders
        </button>
      </div>
      {n && (
        <div className="bg-white border border-[#E2E2DF] rounded-md p-5 font-mono text-xs text-slate-700" data-testid="tree-preview-result">
          {[n.root, n.client, n.property, n.job].map((name, i) => (
            <div key={i} style={{ paddingLeft: i * 18 }} className="flex items-center gap-1.5 py-0.5" data-testid={`tree-level-${i}`}>
              <Folder size={13} className="text-amber-500" /> {name}
            </div>
          ))}
          {data.stages.map((s) => (
            <div key={s.key} style={{ paddingLeft: 72 }} className="py-1">
              <div className="flex items-center gap-1.5 font-semibold" data-testid={`tree-stage-${s.key}`}><Folder size={13} className="text-amber-500" /> {s.name}</div>
              {s.documents.map((d) => (
                <div key={d.kind} style={{ paddingLeft: 18 }} className={`flex items-center gap-1.5 py-0.5 ${d.save ? '' : 'line-through text-slate-300'}`} title={d.label}>
                  <FileText size={12} className="text-slate-400" /> {d.filename}
                </div>
              ))}
            </div>
          ))}
          <div className="mt-4 pt-3 border-t border-[#F1EFEC] font-sans">
            <div className="text-xs font-semibold text-slate-800 mb-1">Already saved in Drive for this job ({data.saved.length})</div>
            {data.saved.map((f) => (
              <div key={f.drive_id} className="flex items-center gap-1.5 text-[11px] text-slate-600 py-0.5">
                <CheckCircle2 size={12} className="text-emerald-600" /> <span className="font-mono">{f.folder_path}/{f.name}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
